import { render } from "./AppImgWrapper.vue?vue&type=template&id=55fda018&scoped=true&ts=true"
import script from "./AppImgWrapper.vue?vue&type=script&lang=ts"
export * from "./AppImgWrapper.vue?vue&type=script&lang=ts"

import "./AppImgWrapper.vue?vue&type=style&index=0&id=55fda018&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src866133389/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55fda018"]])

export default __exports__